import { Component} from '@angular/core';
import { SharedService } from '../services/shared.service';
@Component({
  selector: 'app-loader',
  template: `
  @if ((sharedService.loading$ | async) === true) {
    <div class="loader-overlay">
      <i class="pi pi-spinner pi-spin" style="font-size: 2.5rem"></i>
    </div>
  }
`,
})
export class LoaderComponent {
  constructor(public sharedService: SharedService) {}
}
